var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center loading-container",attrs:{"width":"100%"}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":7,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }